<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i> Genel Ayarlar</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#"></a></li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <h3 class="tile-title"></h3>
            <div class="tile-body">
               <form>
                  <div class="form-group">
                    <label class="control-label">Dil Seçiniz:</label>
                    <select
                      @change="onChange($event)"
                      name="deneme"
                      id="deneme"
                    >
                      <option
                        v-for="(item, index) in language"
                        :key="index"
                        :value="item.id"
                      >
                        {{ item.language_name }}
                      </option>
                    </select>
                  </div>
                </form>
              <form class="form-horizontal">
                <div class="form-group row">
                  <label class="control-label col-md-3">Site Adı</label>
                  <div class="col-md-8">
                    <ckeditor
                      style="border: solid 1px"
                      @ready="onReady"
                      :editor="editor"
                      v-model="result.name"
                      class="form-control"
                      rows="4"
                    ></ckeditor>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="control-label col-md-3">Slogan</label>
                  <div class="col-md-8">
                    <ckeditor
                      style="border: solid 1px"
                      @ready="onReady"
                      :editor="editor"
                      v-model="result.slogan"
                      class="form-control"
                      rows="4"
                    ></ckeditor>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="control-label col-md-3">Logo Yükleme</label>
                  <div class="col-md-8">
                    <div
                      class="fileupload fileupload-new"
                      data-provides="fileupload"
                    >
                      <p style="color: red">{{ fileWarn }}</p>
                      <div class="row">
                        <div class="col-md-4">
                          <div
                            class="fileupload-preview fileupload-exists thumbnail"
                            style="
                              max-width: 200px;
                              max-height: 150px;
                              line-height: 20px;
                            "
                          ></div>
                        </div>
                        

                        <div class="col-md-12">
                          <img
                            id="img"
                            :src="base_img_url+result.imgUrl"
                            style="max-height: 150px"
                          />
                        </div>
                      </div>
                      <div>
                        <span class="btn btn-theme02 btn-file">
                          <input
                            id="file"
                            type="file"
                            ref="file"
                            class="default"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="tile-footer">
              <div class="row">
                <div class="col-md-8 col-md-offset-3">
                  <button
                    @click="uploadFile()"
                    class="btn btn-primary"
                    type="button"
                  >
                    <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet</button
                  >&nbsp;&nbsp;&nbsp;<button
                    @click="sendData()"
                    class="btn btn-secondary"
                  >
                    <i class="fa fa-fw fa-lg fa-times-circle"></i>İptal
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import DecoupledDocument from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
  data() {
    return {
      editor: DecoupledDocument,
      result: {
        name: "",
        slogan: "",
        imgUrl: ""
      
        
      },
      base_img_url:"",
      file: "",
      fileWarn: "",
      language: [],
      language_id: 1,
    };
  },

  created() {
    let dataUrl =
      store.state.base_url + "General/getAllColumnGeneral.php?key=123&lan_id=1";
   
     axios
      .get(dataUrl)
      .then((response) => {

        //conso.log(response);

        this.result.name = response.data.data.site_name;
        this.result.slogan = response.data.data.slogan;
        this.result.imgUrl = response.data.data.logo_url;
        this.base_img_url = store.state.img_base_url;
      })
      .catch((err) => {
        //conso.log(err.response);
      });
        dataUrl = store.state.base_url + "Language/getAllLanguage.php?key=123";
    axios
      .get(dataUrl)
      .then((response) => {
        //conso.log(response);
        this.language = response.data.data;
      })
      .catch((err) => {
        //conso.log(err.response);
      });
  },
  

  methods: {
    reload: function () {
      location.reload();
    },
    onChange(event) {
      this.language_id = event.target.value;
       console.log(this.language_id);
       let dataUrl =
      store.state.base_url + "General/getAllColumnGeneral.php?key=123&lan_id="+this.language_id;
   
     axios
      .get(dataUrl)
      .then((response) => {

        //conso.log(response);

        this.result.name = response.data.data.site_name;
        this.result.slogan = response.data.data.slogan;
        this.result.imgUrl = response.data.data.logo_url;
        this.base_img_url = store.state.img_base_url;
      })
      .catch((err) => {
        //conso.log(err.response);
      });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    uploadFile: function () {
      this.file = this.$refs.file.files[0];

      if (!this.$refs.file.files[0]) {
        return this.sendData();
      }

      var result = this.result;
      var sendData = this.sendData;

      //conso.log(this.file);
      if (this.file.size > 2500000) {
        this.fileWarn =
          "Yükleyeceğiniz Dosya Boyutu 2.5 Mb'yi Aşamaz!  " +
          " Dosya Boyutunuz : " +
          this.file.size / 1000000 +
          "Mb";
        //conso.log("dosya boyutu büyük");
        return;
      }

      let formData = new FormData();
      formData.append("file", this.file);
      var admin_id = localStorage.getItem("id");
      var admin_token = localStorage.getItem("token");
      var query =
        store.state.img_upload_url +
        "?id=" +
        admin_id +
        '&token="' +
        admin_token +
        '"';

      axios
        .post(query, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          //conso.log(response);

          if (response.data.result) {
            //conso.log("işlem başarılı");

            result.imgUrl = response.data.data;

            sendData();
          } else {
            //conso.log("işlem başarısız");
          }
        })
        .catch(function (error) {
          //conso.log(error);
        });
    },

    sendData: function () {
      var url = store.state.base_url + "General/updateGeneral.php?key=123";

      var datas = {
        admin_id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("token"),
        site_name: this.result.name,
        slogan: this.result.slogan,
        logo_url: this.result.imgUrl,
        lan_id: this.language_id,
      };

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            location.reload();
          }
          //conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
        
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/GeneralSettings.vue